module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"_title":"Exploring the Power of Life","subtitle":"Enabling Biomedical Innovation with Synthetic Biological Technology"},"zh":{"_title":"探索生命的力量","subtitle":"用合成生物学技术赋能生物医药创新"}}')
  delete Component.options._Ctor
}
